import { Injectable } from '@angular/core';

@Injectable()
export class ContractModelService {

  model: any;
  futureAccruals = 0;
  payedAccruals = 0;

  setData(data) {
    this.model = data;
  }

  getData() {
    return this.model;
  }

  removeData() {
    this.model = null;
  }

  setAccrualsConfig(config) {
    this.futureAccruals = config.futureAccruals;
    this.payedAccruals = config.payedAccruals;
  }

  getAccrualsConfig() {
    return {
      futureAccruals: this.futureAccruals,
      payedAccruals: this.payedAccruals,
    };
  }

  getFormatPrice() {
    return this.model.arrears.arrearsRentAmount.replace('-', '');
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/contracts.model.service.ts